import React from 'react';
import * as Three from 'three';
import { loadObjWithMaterial } from '../../utils/load-obj';
import path from 'path';

let cached3DWindow = null;

export default {
  name: "sash window",
  prototype: "holes",

  info: {
    title: "Sash Window",
    tag: ['window'],
    description: "Sash Window",
    image: require('./window.png')
  },

  properties: {
    width: {
      label: "Width",
      type: "length-measure",
      defaultValue: {
        length: 90
      }
    },
    // height: {
    //   label: "Height",
    //   type: "length-measure",
    //   defaultValue: {
    //     length: 100
    //   }
    // },
    // altitude: {
    //   label: "Altitude",
    //   type: "length-measure",
    //   defaultValue: {
    //     length: 90
    //   }
    // },
    // thickness: {
    //   label: "Thickness",
    //   type: "length-measure",
    //   defaultValue: {
    //     length: 20
    //   }
    // }
  },

  render2D: function (element, layer, scene) {
    const STYLE_HOLE_BASE = { stroke: '#777', strokeWidth: '2px', fill: '#FFF' };
    const STYLE_HOLE_SELECTED = {
      stroke: '#000',
      strokeWidth: '2px',
      fill: '#FFF',
      cursor: 'move'
    };
    let holeWidth = element.properties.get('width').get('length');
    let holeThickness = 20;
    let epsilon = holeThickness / 2;
    let holePath = `M${0} ${-epsilon}  L${holeWidth} ${-epsilon}  L${holeWidth} ${epsilon}  L${0} ${epsilon}  z`;
    let smallHolePath = `M${0} ${-2}  L${holeWidth} ${-2}  L${holeWidth} ${2}  L${0} ${2}  z`;
    let holeStyle = element.selected ? STYLE_HOLE_SELECTED : STYLE_HOLE_BASE;
    let length = element.properties.get('width').get('length');
    return (
      <g transform={`translate(${-length / 2}, 0)`}>
        <path key="1" d={holePath} style={holeStyle} />
        <path key="2" d={smallHolePath} style={holeStyle} />
      </g>
    );
  },

  render3D: function (element, layer, scene) {
    let onLoadItem = (object) => {
      let boundingBox = new Three.Box3().setFromObject(object);

      let initialWidth = boundingBox.max.x - boundingBox.min.x;
      let initialHeight = boundingBox.max.y - boundingBox.min.y;
      let initialThickness = boundingBox.max.z - boundingBox.min.z;

      if (element.selected) {
        let box = new Three.BoxHelper(object, 0x99c3fb);
        box.material.linewidth = 2;
        box.material.depthTest = false;
        box.renderOrder = 1000;
        object.add(box);
      }

      let width = element.properties.get('width').get('length');
      let height = 100;
      let thickness = 20;

      object.scale.set(width / initialWidth, height / initialHeight,
        thickness / initialThickness);

      return object;
    };

    if (cached3DWindow) {
      return Promise.resolve(onLoadItem(cached3DWindow.clone()));
    }

    let mtl = require('./sash-window.mtl');
    let obj = require('./sash-window.obj');
    let img = require('./texture.png');

    return loadObjWithMaterial(mtl, obj, path.dirname(img) + '/')
      .then(object => {
        cached3DWindow = object;
        return onLoadItem(cached3DWindow.clone());
      })
  }
};
